import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ImasterContent } from "../interfaces/imaster-content";
import { IResponseService } from "../interfaces/response-service";
import { BaseService } from "./base.service";


@Injectable()
export class FormService extends BaseService {


  constructor(public http: HttpClient) {
    super(http);
  }


  /**
   * @author Jose Wilson Mulato
   * @description obtiene el contenido del servicio para retornarlo a las class store que lo usen
   * @param response
   */
  GetResponseDataService(response: IResponseService): ImasterContent[] {
    return response && response.data ? (response.data as ImasterContent[]) : [];
  }

  /**
    * @author Jose Wilson Mulato
    * @description Obtiene datos de asociado cooperativa si lo es
    * @param idPlace
    */
  async GetDatosColaborador(numIdentificacion: string) {
    let response: any = await super.Get(`getDatosColaborador/${numIdentificacion}`, {});
    return this.GetResponseDataService(response);
  }


  public getIPAddress() {
    return this.http.get("http://api.ipify.org/?format=json");
  }


}



// WEBPACK FOOTER //
// ./src/app/services/form.service.ts